<template>
  <div>
    <Head :title="__(title)" />
    <div class="mb-6 flex justify-between items-center">
      <search-input v-model="form.search" class="w-full max-w-md mr-4" @reset="reset"></search-input>
      <Link v-if="user_access.asset_brand.create" class="btn-indigo" :href="this.route('asset_brand.create')">
        <span>{{ __('Create a New Brand') }}</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">#{{ __('ID') }}</th>
          <th class="px-6 pt-6 pb-4">{{ __('Name') }}</th>
          <th class="px-6 pt-6 pb-4">{{ __('Desc') }}</th>
        </tr>
        <tr v-for="brand in brands.data" :key="brand.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="this.route('asset_brand.edit', brand.id)">
              {{ brand.id }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="this.route('asset_brand.edit', brand.id)">
              {{ brand.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="this.route('asset_brand.edit', brand.id)">
              {{ brand.description }}
            </Link>
          </td>
          <td class="border-t w-px">
            <Link class="px-4 flex items-center" :href="this.route('asset_brand.edit', brand.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="brands.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No data found.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="brands.links" />
  </div>
</template>

    <script>
import { Link, Head } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'

export default {
  metaInfo: { title: 'Category Asset' },
  components: {
    Icon,
    Link,
    Head,
    Pagination,
    SearchInput,
  },
  layout: Layout,
  props: {
    title: String,
    filters: Object,
    brands: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
      user_access: this.$page.props.auth.user.access,
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(this.route('asset_brand'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
